export default __webpack_public_path__ + "static/media/earphones2.812d1ea0.jfif";